"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapSize = void 0;
var iconSize = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 29,
  xl: 34,
  xxl: 38
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var mapSize = function mapSize(size) {
  return iconSize[size];
};

exports.mapSize = mapSize;